'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _configTemplates = require('@/res/configTemplates');

var _NetworkState = require('./state/NetworkState');

var _NetworkState2 = _interopRequireDefault(_NetworkState);

var _BufferState = require('./state/BufferState');

var _BufferState2 = _interopRequireDefault(_BufferState);

var _UserState = require('./state/UserState');

var _UserState2 = _interopRequireDefault(_UserState);

var _Message = require('./Message');

var _Message2 = _interopRequireDefault(_Message);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stateObj = {
    persistence: null,

    settings: _configTemplates.configTemplates.default,
    user_settings: {},
    connection: {
        status: 'connected',
        sessionId: ''
    },
    ui: {
        active_network: 0,
        active_buffer: '',
        last_active_buffers: [],
        app_has_focus: true,
        app_width: 0,
        app_height: 0,
        is_touch: false,
        is_narrow: false,
        favicon_counter: 0,
        current_input: '',
        input_history: [],
        input_history_pos: 0,
        show_advanced_tab: false
    },
    networks: []
};

var userDict = new _vue2.default({
    data: function data() {
        return {
            networks: {}
        };
    }
});

var bufferDict = new _vue2.default({
    data: function data() {
        return {
            networks: {}
        };
    }
});

var messages = [];

var availableStartups = (0, _create2.default)(null);

var state = new _vue2.default({
    data: stateObj,
    methods: {
        exportState: function exportState(includeBuffers) {
            var toExport = {};

            if (includeBuffers) {
                toExport.networks = state.networks.map(function (network) {
                    var networkObj = {
                        id: network.id,
                        name: network.name,
                        connection: {
                            nick: network.connection.nick,
                            server: network.connection.server,
                            port: network.connection.port,
                            tls: network.connection.tls,
                            path: network.connection.path,
                            password: network.password,
                            direct: network.connection.direct,
                            encoding: network.connection.encoding
                        },
                        auto_commands: network.auto_commands,
                        settings: _lodash2.default.cloneDeep(network.settings),
                        username: network.username,
                        gecos: network.gecos,
                        password: network.password,
                        buffers: []
                    };

                    networkObj.buffers = network.buffers.map(function (buffer) {
                        var bufferObj = {
                            name: buffer.name,
                            key: buffer.key,
                            enabled: !!buffer.enabled,
                            settings: _lodash2.default.cloneDeep(buffer.settings)
                        };

                        return bufferObj;
                    });

                    return networkObj;
                });
            }

            toExport.user_settings = state.user_settings;

            return (0, _stringify2.default)(toExport);
        },
        importState: function importState(stateStr) {
            var _this = this;

            var importObj = JSON.parse(stateStr);
            if (importObj && importObj.networks) {
                this.resetState();
                importObj.networks.forEach(function (importNetwork) {
                    var network = new _NetworkState2.default(importNetwork.id, state, userDict, bufferDict);
                    network.name = importNetwork.name;
                    network.connection = (0, _extends3.default)({}, network.connection, importNetwork.connection);
                    network.auto_commands = importNetwork.auto_commands || '';
                    network.settings = importNetwork.settings;

                    network.nick = importNetwork.nick || importNetwork.connection.nick;
                    if (!network.connection.nick && importNetwork.nick) {
                        network.connection.nick = importNetwork.nick;
                    }
                    network.username = importNetwork.username;
                    network.gecos = importNetwork.gecos;
                    network.password = importNetwork.password;

                    _this.networks.push(network);

                    importNetwork.buffers.forEach(function (impBuffer) {
                        var buffer = new _BufferState2.default(impBuffer.name, network.id, state, messages);
                        buffer.key = impBuffer.key;
                        buffer.enabled = !!impBuffer.enabled;
                        buffer.settings = impBuffer.settings;

                        network.buffers.push(buffer);
                    });
                });
            }

            if (importObj && importObj.user_settings) {
                this.user_settings = importObj.user_settings;
            }
        },
        resetState: function resetState() {
            this.$set(this.$data, 'user_settings', {});
            this.$set(this.$data, 'networks', []);
            messages.splice(0);
        },
        setting: function setting(name, val) {
            if (typeof val !== 'undefined') {
                if (val === this.getSetting('settings.' + name)) {
                    return this.setSetting('user_settings.' + name, null);
                }

                return this.setSetting('user_settings.' + name, val);
            }

            var userSetting = this.getSetting('user_settings.' + name);
            var result = typeof userSetting !== 'undefined' ? userSetting : this.getSetting('settings.' + name);

            return result;
        },
        getSetting: function getSetting(name) {
            var parts = name.split('.');
            var val = this.$data;

            for (var i = 0; i < parts.length; i++) {
                val = val[parts[i]];
                if (typeof val === 'undefined') {
                    break;
                }
            }

            return val;
        },
        setSetting: function setSetting(name, newVal) {
            var parts = name.split('.');
            var val = this.$data;

            for (var i = 0; i < parts.length; i++) {
                var propName = parts[i];
                var nextVal = val[propName];

                if (i < parts.length - 1 && typeof nextVal === 'undefined') {
                    nextVal = this.$set(val, propName, {});
                } else if (i === parts.length - 1) {
                    if (newVal === null) {
                        this.$delete(val, propName);
                    } else {
                        this.$set(val, propName, newVal);
                    }
                }

                val = nextVal;
            }

            return val;
        },
        getActiveNetwork: function getActiveNetwork() {
            return this.getNetwork(this.ui.active_network);
        },
        getNetwork: function getNetwork(networkid) {
            var network = _lodash2.default.find(this.networks, {
                id: networkid
            });

            return network;
        },
        getNetworkFromAddress: function getNetworkFromAddress(netAddr) {
            return _lodash2.default.find(this.networks, function (net) {
                var isMatch = netAddr.toLowerCase() === net.connection.server.toLowerCase();
                return isMatch;
            });
        },
        getNetworkFromBncNetId: function getNetworkFromBncNetId(bncnetid) {
            return _lodash2.default.find(this.networks, function (net) {
                return bncnetid === net.connection.bncnetid;
            });
        },
        addNetwork: function addNetwork(name, nick, serverInfo) {
            function networkidReduce(currentMax, network) {
                return network.id > currentMax ? network.id : currentMax;
            }
            var networkid = serverInfo.channelId ? parseInt(serverInfo.channelId, 10) : _lodash2.default.reduce(this.networks, networkidReduce, 0) + 1;

            var network = new _NetworkState2.default(networkid, state, userDict, bufferDict);
            network.name = name;
            network.username = serverInfo.username;
            network.gecos = serverInfo.gecos;
            network.password = serverInfo.password;
            network.connection.nick = nick;
            network.connection.server = serverInfo.server || '';
            network.connection.port = serverInfo.port || 6667;
            network.connection.tls = serverInfo.tls || false;
            network.connection.path = serverInfo.path || '';
            network.password = serverInfo.password || '';
            network.connection.direct = !!serverInfo.direct;
            network.connection.path = serverInfo.path || '';
            network.connection.encoding = serverInfo.encoding || 'utf8';
            network.connection.bncnetid = serverInfo.bncnetid || '';

            if (serverInfo.services) {
                network.services = serverInfo.services;
            }

            this.networks.push(network);

            this.addBuffer(network.id, '*').joined = true;

            var eventObj = { network: network };
            state.$emit('network.new', eventObj);

            return network;
        },
        removeNetwork: function removeNetwork(networkid) {
            var network = this.getNetwork(networkid);
            if (!network) {
                return;
            }

            if (network.state === 'connected') {
                network.ircClient.quit();
            }

            while (network.buffers.length > 0) {
                this.removeBuffer(network.buffers[0]);
            }

            var findNewNetwork = false;
            if (network === this.getActiveNetwork()) {
                findNewNetwork = true;
            }

            var idx = this.networks.indexOf(network);
            this.networks.splice(idx, 1);

            if (findNewNetwork) {
                this.openLastActiveBuffer();
            }

            var eventObj = { network: network };
            state.$emit('network.removed', eventObj);
        },
        getActiveBuffer: function getActiveBuffer() {
            return this.getBufferByName(this.ui.active_network, this.ui.active_buffer);
        },
        setActiveBuffer: function setActiveBuffer(networkid, bufferName) {
            if (!networkid) {
                this.ui.active_network = 0;
                this.ui.active_buffer = '';
            } else {
                if (this.ui.active_network) {
                    this.ui.last_active_buffers.push({
                        networkid: this.ui.active_network,
                        bufferName: this.ui.active_buffer
                    });

                    var lastActive = this.ui.last_active_buffers;
                    this.ui.last_active_buffers = lastActive.splice(lastActive.length - 20);
                }

                this.ui.active_network = networkid;
                this.ui.active_buffer = bufferName;

                var buffer = this.getBufferByName(networkid, bufferName);
                if (buffer && buffer.flags.unread) {
                    buffer.flags.unread = 0;
                }

                if (buffer) {
                    buffer.markAsRead(true);
                }
            }
        },


        openLastActiveBuffer: function openLastActiveBuffer() {
            var targetNetwork = void 0;
            var targetBuffer = void 0;
            var lastActive = this.ui.last_active_buffers;

            for (var i = lastActive.length - 1; i >= 0; i--) {
                var network = this.getNetwork(lastActive[i].networkid);
                if (!network) {
                    continue;
                }

                var buffer = network.bufferByName(lastActive[i].bufferName);
                if (!buffer) {
                    continue;
                }

                targetNetwork = network;
                targetBuffer = buffer;

                lastActive.splice(i);
                break;
            }

            if (!targetBuffer) {
                var _network = this.getActiveNetwork() || this.networks[0];
                if (_network) {
                    targetNetwork = _network;
                    var _buffer = _network.buffers[1];
                    if (_buffer) {
                        targetBuffer = _buffer;
                    } else {
                        targetBuffer = _network.serverBuffer();
                    }
                }
            }

            if (targetBuffer) {
                this.setActiveBuffer(targetNetwork.id, targetBuffer.name);
            } else {
                this.setActiveBuffer();
            }
        },

        updateBufferLastRead: function updateBufferLastRead(networkid, bufferName) {
            var buffer = this.getBufferByName(networkid, bufferName);
            if (buffer) {
                buffer.last_read = Date.now();
                buffer.active_timeout = null;
            }
        },
        getOrAddBufferByName: function getOrAddBufferByName(networkid, bufferName) {
            var network = this.getNetwork(networkid);
            if (!network) {
                return null;
            }

            var toMatch = bufferName.toLowerCase();
            var buffer = _lodash2.default.find(network.buffers, function (b) {
                return b.name.toLowerCase() === toMatch;
            });

            if (!buffer) {
                buffer = this.addBuffer(networkid, bufferName);
            }

            return buffer;
        },
        getBufferByName: function getBufferByName(networkid, bufferName) {
            if (!bufferName) {
                return null;
            }

            var network = this.getNetwork(networkid);
            if (!network) {
                return null;
            }

            var toMatch = bufferName.toLowerCase();
            var buffer = _lodash2.default.find(network.buffers, function (b) {
                return b.name.toLowerCase() === toMatch;
            });

            return buffer;
        },
        addBuffer: function addBuffer(networkid, bufferName) {
            var buffer = this.getBufferByName(networkid, bufferName);
            if (buffer) {
                return buffer;
            }

            var network = this.getNetwork(networkid);
            if (!network) {
                return false;
            }

            buffer = new _BufferState2.default(bufferName, network.id, state, messages);
            network.buffers.push(buffer);

            var eventObj = { buffer: buffer };
            state.$emit('buffer.new', eventObj);

            return buffer;
        },
        removeBuffer: function removeBuffer(buffer) {
            var isActiveBuffer = this.getActiveBuffer() === buffer;

            var network = this.getNetwork(buffer.networkid);
            if (!network) {
                return;
            }

            var eventObj = { buffer: buffer };
            state.$emit('buffer.close', eventObj);

            var bufferIdx = network.buffers.indexOf(buffer);
            if (bufferIdx > -1) {
                network.buffers.splice(bufferIdx, 1);
            }

            var messageIdx = _lodash2.default.findIndex(messages, {
                networkid: network.id,
                buffer: buffer.name
            });
            if (messageIdx > -1) {
                messages.splice(messageIdx, 1);
            }

            if (buffer.isChannel() && buffer.joined) {
                network.ircClient.part(buffer.name);
            }

            if (buffer.isQuery()) {
                var remainingBuffers = state.getBuffersWithUser(network.id, buffer.name);
                if (remainingBuffers.length === 0) {
                    state.removeUser(network.d, {
                        nick: buffer.name
                    });
                }
            }

            if (isActiveBuffer) {
                this.openLastActiveBuffer();
            }

            (0, _keys2.default)(buffer.users).forEach(function (nick) {
                var user = buffer.users[nick];
                delete user.buffers[buffer.id];
            });
        },
        addMessage: function addMessage(buffer, message) {
            if (!buffer) {
                return;
            }

            var user = this.getUser(buffer.networkid, message.nick);
            var bufferMessage = new _Message2.default(message, user);
            if (user && user.ignore) {
                bufferMessage.ignore = true;
            }

            buffer.addMessage(bufferMessage);

            var includeAsActivity = false;
            var typesForActivty = ['privmsg', 'action', 'notice'];
            if (buffer.setting('traffic_as_activity') && message.type === 'traffic') {
                typesForActivty.push('traffic');
            }

            if (typesForActivty.indexOf(message.type) > -1) {
                includeAsActivity = true;
            }

            var isActiveBuffer = buffer.networkid === this.ui.active_network && buffer.name === this.ui.active_buffer;

            var network = buffer.getNetwork();
            var isNewMessage = message.time >= buffer.last_read;
            var isHighlight = !network ? false : Misc.mentionsNick(bufferMessage.message, network.ircClient.user.nick);

            var extraHighlights = (state.setting('highlights') || '').toLowerCase().split(' ');
            if (!isHighlight && extraHighlights.length > 0) {
                extraHighlights.forEach(function (word) {
                    if (!word) {
                        return;
                    }

                    if (bufferMessage.message.toLowerCase().indexOf(word) > -1) {
                        isHighlight = true;
                    }
                });
            }

            if (state.setting('teamHighlights')) {
                var m = bufferMessage.message;
                var patterns = {
                    everyone: /(^|\s)@everybody($|\s|[,.;])/,
                    channel: /(^|\s)@channel($|\s|[,.;])/,
                    here: /(^|\s)@here($|\s|[,.;])/
                };
                if (m.match(patterns.everyone) || m.match(patterns.channel)) {
                    isHighlight = true;
                }

                if (m.match(patterns.here) && network && !network.away) {
                    isHighlight = true;
                }
            }

            bufferMessage.isHighlight = isHighlight;

            if (isNewMessage && isActiveBuffer && state.ui.app_has_focus) {
                buffer.last_read = message.time;
            }

            if (isNewMessage && includeAsActivity && !isActiveBuffer && !bufferMessage.ignore) {
                buffer.incrementFlag('unread');
                if (isHighlight) {
                    buffer.flag('highlight', true);
                }
            }

            var settingAlertOn = buffer.setting('alert_on');
            var isSelf = !network ? false : message.nick === network.nick;
            if (isNewMessage && settingAlertOn !== 'never' && message.type !== 'nick' && message.type !== 'mode' && message.type !== 'traffic' && !buffer.isSpecial() && !bufferMessage.ignore && !isSelf) {
                var notifyTitle = '';
                var notifyMessage = message.nick ? message.nick + ': ' : '';
                notifyMessage += message.message;

                if (isHighlight) {
                    notifyTitle = 'You were mentioned in ' + buffer.name;
                } else if (settingAlertOn === 'message' && !isHighlight) {
                    notifyTitle = buffer.name;
                }

                if (notifyTitle) {
                    this.$emit('notification.show', notifyMessage, {
                        title: notifyTitle,
                        onclick: function onclick() {
                            state.setActiveBuffer(buffer.networkid, buffer.name);

                            if (parent && parent.focus) {
                                parent.focus();
                            }
                            if (window.focus) {
                                window.focus();
                            }
                        }
                    });
                }
            }

            if (isActiveBuffer && !state.ui.app_has_focus && message.type !== 'traffic' && (buffer.setting('flash_title') === 'message' || buffer.setting('flash_title') === 'highlight' && isHighlight)) {
                this.$emit('notification.title', true);
            }

            this.$emit('message.new', { message: bufferMessage, buffer: buffer });
        },
        getUser: function getUser(networkid, nick, usersArr_) {
            var user = null;
            var users = usersArr_;

            if (!users) {
                var network = this.getNetwork(networkid);
                if (network) {
                    users = network.users;
                }
            }

            if (users) {
                user = users[nick.toLowerCase()];
            }

            return user;
        },
        usersTransaction: function usersTransaction(networkid, fn) {
            var network = this.getNetwork(networkid);
            if (!network) {
                return;
            }

            var users = _lodash2.default.clone(network.users);
            fn(users);
            network.users = users;
        },
        addUser: function addUser(networkid, user, usersArr_) {
            var network = null;

            if (typeof networkid === 'number') {
                network = this.getNetwork(networkid);
            } else {
                network = networkid;
            }

            if (!network) {
                return null;
            }

            var usersArr = usersArr_ || network.users;
            var userObj = null;

            if (!usersArr[user.nick.toLowerCase()]) {
                userObj = usersArr[user.nick.toLowerCase()] = new _UserState2.default(user);
            } else {
                userObj = state.getUser(network.id, user.nick, usersArr);
                _lodash2.default.each(user, function (val, prop) {
                    if (typeof val !== 'undefined') {
                        userObj[prop] = val;
                    }
                });
            }

            return userObj;
        },
        removeUser: function removeUser(networkid, user) {
            var network = this.getNetwork(networkid);
            if (!network) {
                return;
            }

            var buffers = state.getBuffersWithUser(networkid, user.nick);
            buffers.forEach(function (buffer) {
                state.removeUserFromBuffer(buffer, user.nick);
            });

            this.$delete(network.users, user.nick.toLowerCase());
        },
        addMultipleUsersToBuffer: function addMultipleUsersToBuffer(buffer, newUsers) {
            var _this2 = this;

            var network = this.getNetwork(buffer.networkid);
            var bufUsers = _lodash2.default.clone(buffer.users);

            state.usersTransaction(network.id, function (users) {
                newUsers.forEach(function (newUser) {
                    var user = newUser.user;
                    var modes = newUser.modes;
                    var userObj = state.getUser(network.id, user.nick, users);

                    if (!userObj) {
                        userObj = _this2.addUser(network, user, users);
                    }
                    bufUsers[userObj.nick.toLowerCase()] = userObj;

                    if (!userObj.buffers[buffer.id]) {
                        state.$set(userObj.buffers, buffer.id, {
                            modes: modes || [],
                            buffer: buffer
                        });
                    } else {
                        userObj.buffers[buffer.id].modes = modes || [];
                    }
                });
            });

            buffer.users = bufUsers;
        },
        addUserToBuffer: function addUserToBuffer(buffer, user, modes) {
            var network = this.getNetwork(buffer.networkid);
            var userObj = state.getUser(network.id, user.nick);

            if (!userObj) {
                userObj = this.addUser(network, user);
            } else {
                _lodash2.default.each(user, function (val, prop) {
                    if (userObj[prop] !== val) {
                        userObj[prop] = val;
                    }
                });
            }

            buffer.addUser(userObj);

            if (!userObj.buffers[buffer.id]) {
                state.$set(userObj.buffers, buffer.id, {
                    modes: modes || [],
                    buffer: buffer
                });
            } else {
                state.$set(userObj.buffers[buffer.id], 'modes', modes || []);
            }
        },
        removeUserFromBuffer: function removeUserFromBuffer(buffer, nick) {
            buffer.removeUser(nick);
        },
        getBuffersWithUser: function getBuffersWithUser(networkid, nick) {
            var network = this.getNetwork(networkid);
            if (!network) {
                return [];
            }

            var normalisedNick = nick.toLowerCase();
            var buffers = [];
            network.buffers.forEach(function (buffer) {
                if (buffer.users[normalisedNick] || normalisedNick === buffer.name.toLowerCase()) {
                    buffers.push(buffer);
                } else if (nick === network.nick && buffer.isQuery()) {
                    buffers.push(buffer);
                }
            });

            return buffers;
        },
        changeUserNick: function changeUserNick(networkid, oldNick, newNick) {
            var network = this.getNetwork(networkid);
            if (!network) {
                return;
            }

            var user = state.getUser(network.id, oldNick);
            if (!user) {
                return;
            }

            var normalisedNew = newNick.toLowerCase();
            var normalisedOld = oldNick.toLowerCase();

            user.nick = newNick;

            if (normalisedOld !== normalisedNew) {
                state.$set(network.users, normalisedNew, network.users[normalisedOld]);
                state.$delete(network.users, normalisedOld);

                (0, _keys2.default)(user.buffers).forEach(function (bufferId) {
                    var buffer = user.buffers[bufferId].buffer;
                    state.$set(buffer.users, normalisedNew, buffer.users[normalisedOld]);
                    state.$delete(buffer.users, normalisedOld);
                });
            }

            var buffer = this.getBufferByName(network.id, oldNick);
            if (buffer) {
                buffer.rename(newNick);
            }
        },
        getStartups: function getStartups() {
            return availableStartups;
        }
    }
});

exports.default = state;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["state"]
window._kiwi_exports.libs.state = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/state.js
// module id = LnP8
// module chunks = 1